import React from 'react';

/**
 * Pagination tableau (style duo), client ou serveur.
 * @param {'prev'|'next'} direction
 */
export default function DuoTablePagination({
  currentPage,
  totalPages,
  totalItems,
  pageSize = 10,
  onPageChange,
  itemLabel = 'entrée',
}) {
  if (!totalItems) {
    return (
      <div className="duo-footer-bar">
        <span>Aucun résultat à afficher</span>
      </div>
    );
  }

  const indexOfFirst = (currentPage - 1) * pageSize + 1;
  const indexOfLast = Math.min(currentPage * pageSize, totalItems);
  const plural = totalItems > 1 ? 's' : '';

  return (
    <div className="duo-footer-bar">
      <span>
        {indexOfFirst} – {indexOfLast} sur {totalItems} {itemLabel}
        {plural}
      </span>
      <ul className="duo-pagination">
        <li>
          <button
            type="button"
            className="duo-btn duo-btn--ghost"
            disabled={currentPage <= 1}
            onClick={() => onPageChange('prev')}
          >
            Précédent
          </button>
        </li>
        <li>
          <span className="duo-pagination__info px-2">
            Page {currentPage} / {Math.max(totalPages, 1)}
          </span>
        </li>
        <li>
          <button
            type="button"
            className="duo-btn duo-btn--primary"
            disabled={currentPage >= totalPages}
            onClick={() => onPageChange('next')}
          >
            Suivant
          </button>
        </li>
      </ul>
    </div>
  );
}
